import React from 'react';
import EditSelect from '../../../table/EditSelect';
import { renderEditMoneyComponent, renderNullFloatValues } from '../../../../pages/index/Shared';
import { floatRenderer } from '../../../../services/formatSvc';
import { getLookupObject } from '../../../../utils/table';
import FilterMultiSelect from '../../../table/FilterMultiSelect';

const renderCompletePercent = (fact, plan = 40) => {
  if (!plan) return '';
  return `${floatRenderer(fact / plan * 100)}%`;
};

const roles = ['определяет значение', 'обеспечивает достижение'];
const renderEditRoleComponent = (_props) => (
  <EditSelect
    value={_props.value}
    onChange={_props.onChange}
    data={roles.map((r) => ({ id: r, name: r }))}
    stringValue
  />
);

export const getColumns = (years, { canEdit, canEditRestricted, canEditStratKpiRoles }, filterLookups, closedPeriods = []) => {
  const colsLeft = [
    {
      title: '№',
      field: 'num',
      editable: 'never',
      lookup: filterLookups.num,
      filterCellStyle: { maxWidth: '181px', width: '9%', minWidth: '181px' },
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Показатель',
      field: 'name',
      editable: 'never',
      lookup: filterLookups.name,
      filterCellStyle: { minWidth: '450px', maxWidth: '450px' },
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Единица',
      field: 'unit',
      editable: 'never',
    },
  ];

  // const colsMiddle = [];
  const colsMiddle = years.reduce(
    (acc, year) => [
      ...acc,
      {
        title: `План ${year}`,
        field: `plan${year}`,
        render: (rowData) => renderNullFloatValues(rowData[`plan${year}`]),
        editable: () => canEditRestricted && checkYearOnCloseWithPerms(year, closedPeriods, canEdit),
        editComponent: renderEditMoneyComponent,
        filterCellStyle: { minWidth: '135px' },
      },
      {
        title: `Факт ${year}`,
        field: `fact${year}`,
        render: (rowData) => renderNullFloatValues(rowData[`fact${year}`]),
        editable: () => canEditRestricted && checkYearOnCloseWithPerms(year, closedPeriods, canEdit),
        editComponent: renderEditMoneyComponent,
        filterCellStyle: { minWidth: '135px' },
      },
      {
        title: `% выполнения ${year}`,
        // field: `complete${year}`,
        render: (rowData) => renderCompletePercent(rowData[`fact${year}`], rowData[`plan${year}`]),
        filterCellStyle: { minWidth: '150px' },
      },
    ],
    [],
  );
  const colsRight = [
    {
      title: 'Влияние на показатели',
      field: 'stratKpiRole',
      // render: (rowData) => renderNamesString(rowData.personsInCharge),
      editable: () => canEditStratKpiRoles,
      editComponent: renderEditRoleComponent,
      filterCellStyle: { minWidth: '300px' },
    },
  ];

  return [...colsLeft, ...colsMiddle, ...colsRight];
};

export const getFilterLookups = (data) => ({
  num: getLookupObject(data, 'num'),
  name: getLookupObject(data, 'name'),
});

const checkYearOnCloseWithPerms = (year, closedPeriods, canEdit) => canEdit || !closedPeriods.includes(year);
